import { AddVendorComponent } from './add-vendor/add-vendor.component';
import { ViewVendorComponent } from './view-vendor/view-vendor.component';
import { SingleViewVendorComponent } from './view-vendor/single-view-vendor/single-view-vendor';
import { EditVendorComponent } from './edit-vendor/edit-vendor.component';
export const VendorDeclaration = [
    AddVendorComponent , ViewVendorComponent, EditVendorComponent, SingleViewVendorComponent
];
